module.exports = __webpack_public_path__ + "img/photo2_7.2d5a42c3.jpg";